import React, { forwardRef } from 'react'
import cx from 'classnames'

import { Text, TextStyle } from 'components/dataDisplay'

import s from './Label.scss'


export const bgColors = [ 'gold-30', 'black', 'brown-red' ] as const
export const textColors = [ 'white', 'black', 'gold-30' ] as const
export const directions = [ 'left', 'right' ] as const
export const indents = [ 16, 32, 40, 56 ] as const

export type BgColor = typeof bgColors[number]
export type TextColor = typeof textColors[number]
export type Direction = typeof directions[number]
export type Indent = typeof indents[number]

type LabelProps = {
  className?: string
  absolute?: boolean
  title: string | Intl.Message
  bgColor: BgColor
  textColor: TextColor
  direction?: Direction
  indent?: Indent
  withTail?: boolean
  style?: Extract<TextStyle, 'eye1' | 'eye2' | 'eye3' | 't5' | 'h5'>
  'data-testid'?: string
}

const Label = forwardRef<HTMLDivElement, LabelProps>((props, ref) => {
  const { className, absolute = false, title, bgColor, textColor, indent, direction = 'left', withTail, style = 'eye3', 'data-testid': dataTestId } = props

  const rootClassName = cx(s.label, className, absolute ? 'absolute' : 'relative', {
    [`bg-${bgColor}`]: bgColor,
    [s[`indent-${indent}`]]: indent,
    [s[`direction-${direction}`]]: direction,
    [s.withTail]: withTail,
  })

  return (
    <div className={rootClassName} data-testid={dataTestId}>
      <Text ref={ref} message={title} style={style} color={textColor} />
    </div>
  )
})

Label.displayName = 'Label'


export default Label
